import React, { useEffect } from 'react'

const Toast = ({open, heading}) => {

    useEffect( () => {

        setTimeout(() => {
            open&&open(false)
        }, 4000);
        
    },[])
    
  return (
    <div>
        
        <div className="toast">{heading?heading:"Done"}</div>

        
        
    </div>
  )
}

export default Toast